import {TimestampRoot} from './components/timestamp-root';
import {TimestampColorful} from './variant/colorfull';
import {TimestampText} from './variant/text';

export const Timestamp = Object.assign(TimestampRoot, {
	Colorful: TimestampColorful,
	Text: TimestampText,
});
